import React from "react";
import { Row, Typography, Select, Checkbox } from "antd";
import {
  EmployeeFollowUpEventQuizStatus,
  AnsweredBy,
  QuizAnsweredBy,
  NotApplicableSuffix,
  NotApplicableLabel,
} from "../common/GeneralConfigurations";
import "./EmployeeFollowUpEventDetailListForm.css";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";

const { Text, Title } = Typography;
const { Option } = Select;

const QuizQuestionOneChoiceForm = ({
  quizIsAnsweredBy,
  quizStatusId,
  readonly,
  answeredBy,
  questionText,
  isRequired,
  allowNotApplicable,
  questionDomainOptions,
  errorMessage,
  fieldName,
  consultantAnswer,
  consultantAllowNotApplicableAnswer,
  supervisorAnswer,
  supervisorAllowNotApplicableAnswer,
  handleSelectChange,
  isReadOnly,
  onNotApplicable,
  onBlur,
}) => {
  const isNotApplicable = true;

  const getDomainOptions = (options, allowNotApplicable) => {
    let domainOptions = [];
    options &&
      options.map((op) => {
        domainOptions.push({
          id: op.id,
          name: op.name,
        });
      });
    return domainOptions;
  };

  const getDomainOptionsValue = (options, selectedId) => {
    if (selectedId) {
      let domainOptions = getDomainOptions(options, true);
      const selected = domainOptions.filter((op) => op.id === +selectedId);
      return selected[0].name;
    }
    return undefined;
  };

  return (
    <>
      {/* Consultant view or Supervisor view and wating for consultant answer */}
      {quizStatusId ===
        EmployeeFollowUpEventQuizStatus.AwaitsResponseFromConsultant && (
        // (answeredBy === AnsweredBy.Consultant || answeredBy === AnsweredBy.Both) &&
        <div className="quiz-question-person">
          {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}
          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea placeholder={questionText} disabled autoSize />
          </Row>

          <p className="quiz-element-margin">
            <Select
              name={fieldName}
              className="quiz-dropdown"
              disabled={isReadOnly(
                allowNotApplicable === true
                  ? consultantAllowNotApplicableAnswer
                  : false
              )}
              onChange={(e) => handleSelectChange(e, fieldName)}
              value={supervisorAnswer || undefined}
              defaultValue={getDomainOptionsValue(
                questionDomainOptions,
                consultantAnswer
              )}
              placeholder="Choose an option"
            >
              {getDomainOptions(questionDomainOptions, allowNotApplicable) &&
                getDomainOptions(questionDomainOptions, allowNotApplicable).map(
                  (op) => (
                    <Option key={op.id} value={op.id}>
                      {op.name}
                    </Option>
                  )
                )}
            </Select>
          </p>
          {allowNotApplicable === true && (
            <p className="quiz-element-margin">
              <Checkbox
                name={fieldName + NotApplicableSuffix}
                defaultChecked={consultantAllowNotApplicableAnswer}
                checked={consultantAllowNotApplicableAnswer}
                onChange={(value) => onNotApplicable(value, fieldName)}
                disabled={readonly}
              >
                {NotApplicableLabel}
              </Checkbox>
            </p>
          )}
          {errorMessage && <Text type="danger">{errorMessage}</Text>}
        </div>
      )}
      {/* Supervisor view for regular type events, that are answered only by the supervisor */}
      {quizIsAnsweredBy === QuizAnsweredBy.Supervisor &&
        quizStatusId ===
          EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor &&
        (answeredBy === AnsweredBy.Supervisor ||
          answeredBy === AnsweredBy.Both) && (
          <>
            {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}
            <Row className="question-title">
              <Text type="danger">{isRequired ? "* " : ""}</Text>
              <AdnTextArea placeholder={questionText} disabled autoSize />
            </Row>

            <p className="quiz-element-margin">
              <Select
                name={fieldName}
                className="quiz-dropdown"
                disabled={isReadOnly(
                  allowNotApplicable === true
                    ? supervisorAllowNotApplicableAnswer
                    : false
                )}
                onChange={(e) => handleSelectChange(e, fieldName)}
                value={supervisorAnswer || undefined}
                defaultValue={getDomainOptionsValue(
                  questionDomainOptions,
                  supervisorAnswer
                )}
                placeholder="Choose an option"
              >
                {getDomainOptions(questionDomainOptions, allowNotApplicable) &&
                  getDomainOptions(
                    questionDomainOptions,
                    allowNotApplicable
                  ).map((op) => (
                    <Option key={op.id} value={op.id}>
                      {op.name}
                    </Option>
                  ))}
              </Select>
            </p>
            {allowNotApplicable === true && (
              <p className="quiz-element-margin">
                <Checkbox
                  name={fieldName + NotApplicableSuffix}
                  defaultChecked={supervisorAllowNotApplicableAnswer}
                  checked={supervisorAllowNotApplicableAnswer}
                  onChange={(value) => onNotApplicable(value, fieldName)}
                  disabled={readonly}
                >
                  {NotApplicableLabel}
                </Checkbox>
              </p>
            )}
            {errorMessage && <Text type="danger">{errorMessage}</Text>}
          </>
        )}
      {/* Supervisor view for evaluation type events */}
      {quizIsAnsweredBy === QuizAnsweredBy.Consultant &&
        quizStatusId ===
          EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor && (
          <>
            {/* consultant answer */}
            {(answeredBy === AnsweredBy.Consultant ||
              answeredBy === AnsweredBy.Both) && (
              <>
                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea placeholder={questionText} disabled autoSize />
                </Row>
                {allowNotApplicable === true &&
                consultantAllowNotApplicableAnswer === isNotApplicable ? (
                  <>
                    <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                    <p className="quiz-not-applicable">{NotApplicableLabel}</p>
                  </>
                ) : (
                  <p>
                    <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                    {getDomainOptionsValue(
                      questionDomainOptions,
                      consultantAnswer
                    )}
                  </p>
                )}
              </>
            )}
            {/* supervisor answer */}
            {(answeredBy === AnsweredBy.Supervisor ||
              answeredBy === AnsweredBy.Both) && (
              <div className="quiz-question-person">
                <Row className="question-title">
                  <Text type="danger">{isRequired ? "* " : ""}</Text>
                  <AdnTextArea placeholder={questionText} disabled autoSize />
                </Row>
                <p className="quiz-element-margin">
                  <Select
                    name={fieldName}
                    className="quiz-dropdown"
                    disabled={isReadOnly(
                      allowNotApplicable === true
                        ? supervisorAllowNotApplicableAnswer
                        : false
                    )}
                    onChange={(e) => handleSelectChange(e, fieldName)}
                    value={supervisorAnswer || undefined}
                    defaultValue={getDomainOptionsValue(
                      questionDomainOptions,
                      supervisorAnswer
                    )}
                    placeholder="Choose an option"
                    onBlur={onBlur}
                  >
                    {getDomainOptions(
                      questionDomainOptions,
                      allowNotApplicable
                    ) &&
                      getDomainOptions(
                        questionDomainOptions,
                        allowNotApplicable
                      ).map((op) => (
                        <Option key={op.id} value={op.id}>
                          {op.name}
                        </Option>
                      ))}
                  </Select>
                </p>
                {allowNotApplicable === true && (
                  <p className="quiz-element-margin">
                    <Checkbox
                      name={fieldName + NotApplicableSuffix}
                      defaultChecked={supervisorAllowNotApplicableAnswer}
                      checked={supervisorAllowNotApplicableAnswer}
                      onChange={(value) => onNotApplicable(value, fieldName)}
                      disabled={readonly}
                    >
                      {NotApplicableLabel}
                    </Checkbox>
                  </p>
                )}
                {errorMessage && <Text type="danger">{errorMessage}</Text>}
              </div>
            )}
          </>
        )}
      {/* when quiz is answered */}
      {quizStatusId === EmployeeFollowUpEventQuizStatus.Answered && (
        <>
          {/* consultant answer */}
          <Row className="question-title">
            <Text type="danger">{isRequired ? "* " : ""}</Text>
            <AdnTextArea placeholder={questionText} disabled autoSize />
          </Row>
          {(consultantAnswer || consultantAllowNotApplicableAnswer) && (
            <p>
              <span code strong className="answer-consultant">
                Consultant:{" "}
              </span>
              {consultantAnswer > 0 && (
                <Text>
                  {getDomainOptionsValue(
                    questionDomainOptions,
                    consultantAnswer
                  )}
                </Text>
              )}
              {consultantAllowNotApplicableAnswer === isNotApplicable && (
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              )}
            </p>
          )}
          {/* supervisor answer */}
          {(supervisorAnswer || supervisorAllowNotApplicableAnswer) && (
            <p>
              <span className="answer-supervisor">Supervisor: </span>
              {supervisorAnswer > 0 && (
                <Text>
                  {getDomainOptionsValue(
                    questionDomainOptions,
                    supervisorAnswer
                  )}
                </Text>
              )}
              {supervisorAllowNotApplicableAnswer === isNotApplicable && (
                <Text type="warning" className="quiz-not-applicable">
                  {NotApplicableLabel}
                </Text>
              )}
            </p>
          )}
        </>
      )}
    </>
  );
};

export default QuizQuestionOneChoiceForm;
